export default "__VITE_ASSET__sz_ED_QX__"